module.exports = __webpack_public_path__ + "static/media/share-whatsapp.18a91af7.png";